<nav class="app-nav">
  <div class="nav-brand">
    @if (orgLogoUrl(); as logoUrl) {
      <img class="nav-org-logo" [src]="logoUrl" [alt]="orgDisplayName()" />
    } @else {
      <div class="nav-logo-mark">{{ orgLogoInitial() }}</div>
      <div class="nav-logo-text">
        <span class="logo-title">{{ orgDisplayName() }}</span>
      </div>
    }
  </div>

  <!-- Nav items moved to <lib-side-nav /> on the right edge. Header now only
       carries brand + user/notification actions. -->

  <div class="nav-actions">
    <button class="nav-icon-btn" type="button">
      <i class="pi pi-bell"></i>
    </button>
    <button class="nav-icon-btn" type="button">
      <i class="pi pi-comments"></i>
    </button>
    <button
      class="nav-avatar"
      type="button"
      aria-label="Open profile menu"
      aria-haspopup="true"
      (click)="toggleProfileMenu($event)"
    >
      @if (avatarPicture(); as picture) {
        <img [src]="picture" [alt]="avatarInitial()" />
      } @else {
        {{ avatarInitial() }}
      }
    </button>
    <p-menu
      #profileMenu
      [model]="profileMenuItems"
      [popup]="true"
      appendTo="body"
      styleClass="profile-menu"
    />
  </div>
</nav>
